import type UserAgentInfo from 'js/lib/useragent';

import inServerContext from 'bundles/ssr/util/inServerContext';
import useMobile from 'bundles/teams-v2/utils/useMobile';

const useMobileScreen = (userAgent: UserAgentInfo) => {
  const { isMobile } = useMobile();
  if (inServerContext) {
    return {
      isMobileScreen: userAgent.isMobile || userAgent.isMobileBrowser || userAgent.isMobilePhoneBrowser,
    };
  }

  return {
    isMobileScreen: isMobile,
  };
};

export default useMobileScreen;
